import type { SectionsConfig } from '@backoffice-frontend/authenticated-app-view'
import {
  hasAccess,
  useBoumClaimsConsumer,
} from '@backoffice-frontend/restricted'
import { useMemo } from 'react'
import type { CommandPaletteItem } from '../types'

export const useCommandPaletteItems = (
  sections: SectionsConfig,
  getAreaTranslation: (id: string) => string,
): CommandPaletteItem[] => {
  const boumClaim = useBoumClaimsConsumer()

  return useMemo(() => {
    const items: CommandPaletteItem[] = []

    for (const section of sections) {
      if (!section) continue
      if (section.hiddenInNavBar) continue

      const sectionLabel = section.label

      for (const area of section.areas) {
        if (!area) continue

        const hasUserAccess = hasAccess({
          boumClaim,
          allowedRights: area.requiredRight ? [area.requiredRight] : undefined,
        })

        if (!hasUserAccess) continue

        items.push({
          id: area.id,
          label: getAreaTranslation(area.id),
          sectionLabel,
          path: area.route.path,
          requiredRight: area.requiredRight,
        })
      }
    }

    return items
  }, [sections, getAreaTranslation, boumClaim])
}
